export enum StorageKeys {
  AUTH_PROVIDER = 'authProvider',
  USED_SUPABASE_PROVIDER_ID = 'usedSupabaseProviderId',
  USER_ID = 'userId',
  USER_ROLE = 'userRole',
  ORGANIZATION_TOKEN = 'organizationToken',
  SITE_TOKEN = 'siteToken',
}

export class StorageService {
  static setItem(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  static getItem(key: string) {
    return localStorage.getItem(key);
  }

  static removeItem(key: string) {
    localStorage.removeItem(key);
  }
}
